/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_CardInputs */

const en_guide_what_is_json_card = /** @type {(inputs: Guide_What_Is_Json_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn what JSON is, its syntax, data types, and why it became the web's standard data format.`)
};

const ko_guide_what_is_json_card = /** @type {(inputs: Guide_What_Is_Json_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이 무엇인지, 구문, 데이터 타입, 그리고 웹의 표준 데이터 포맷이 된 이유를 알아보세요.`)
};

const ja_guide_what_is_json_card = /** @type {(inputs: Guide_What_Is_Json_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONとは何か、その構文、データ型、そしてなぜWebの標準データ形式になったのかを学びましょう。`)
};

/**
* | output |
* | --- |
* | "Learn what JSON is, its syntax, data types, and why it became the web's standard data format." |
*
* @param {Guide_What_Is_Json_CardInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_card = /** @type {((inputs?: Guide_What_Is_Json_CardInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_CardInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_card(inputs)
	if (locale === "ko") return ko_guide_what_is_json_card(inputs)
	return ja_guide_what_is_json_card(inputs)
});